export default __webpack_public_path__ + "static/media/qhsawari.53ae5c18.jpeg";